import { supabase } from '../client';
import type { NotificationRow } from '@munawb/types';

export async function fetchNotifications(
  user_id: string,
  user_dept: string | null,
  unread_only = false
) {
  let query = supabase
    .from('notifications')
    .select('*')
    .order('created_at', { ascending: false })
    .limit(50);

  // الإشعارات الشخصية أو إشعارات القسم
  if (user_dept) {
    query = query.or(`target_user.eq.${user_id},target_dept.eq.${user_dept}`);
  } else {
    query = query.eq('target_user', user_id);
  }

  if (unread_only) query = query.eq('is_read', false);

  const { data, error } = await query;
  if (error) throw error;
  return data as NotificationRow[];
}

export async function markNotificationsRead(notif_ids: string[]) {
  const { error } = await supabase
    .from('notifications')
    .update({ is_read: true, read_at: new Date().toISOString() })
    .in('id', notif_ids);

  if (error) throw error;
}

// Realtime subscription للإشعارات الجديدة
export function subscribeToNotifications(
  user_id: string,
  onNew: (notif: NotificationRow) => void
) {
  return supabase
    .channel(`notifications:${user_id}`)
    .on(
      'postgres_changes',
      {
        event:  'INSERT',
        schema: 'public',
        table:  'notifications',
        filter: `target_user=eq.${user_id}`,
      },
      (payload) => onNew(payload.new as NotificationRow)
    )
    .subscribe();
}
